const sectionTemplateAction = {
    NEW_SECTION_TEMPLATE : 'new section template',

    BACKUP : 'backup',

    RELOAD_SECTION_RULES : 'reload section rules',

    SAVE : 'save',

    DISCARD : 'discard',

    DELETE : 'delete',

    MARK_IN_PRODUCTION : 'mark in production'

};

angular.module('gw-um-j2js')
    .constant('sectionTemplateAction', sectionTemplateAction);